function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback } from "react";
import { useSdkContext } from "~/components/contexts";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { getTriggerPoint } from "~/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";
import { useActiveElementForNewWindow } from "~/lib/hooks";
import { Container, Description, FacebookIframe } from "./styles";
export const FollowUsOnFacebook = ({
  ...props
}) => {
  const {
    config,
    handleTrackGA,
    handleTrackGA4
  } = useSdkContext();
  const {
    campaignName,
    lastSubscribedNewsletter,
    variant
  } = useNewsletterContext();
  const {
    activeElement
  } = useActiveElementForNewWindow();
  const iframeReference = useCallback(reference => {
    if (activeElement !== reference) return;
    handleTrackGA({
      action: "Newsletter Sign Up/Thank you/Facebook/Like",
      category: "Newsletter",
      label: ""
    });
    handleTrackGA4({
      action: "click",
      category: "nl",
      customized_parameters: {
        internal_campaign: campaignName !== null && campaignName !== void 0 ? campaignName : "",
        newsletter_name: lastSubscribedNewsletter !== null && lastSubscribedNewsletter !== void 0 ? lastSubscribedNewsletter : "",
        trigger_point: getTriggerPoint(variant)
      },
      subcategory: "like"
    });
  }, [activeElement, handleTrackGA, handleTrackGA4, campaignName, variant, lastSubscribedNewsletter]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "follow-us-on-facebook"
  }), /*#__PURE__*/React.createElement(Description, null, " Follow us on Facebook to get our latest news."), /*#__PURE__*/React.createElement(FacebookIframe, {
    allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
    frameBorder: 0,
    height: "21",
    ref: iframeReference,
    scrolling: "no",
    src: config.facebook.likeUrl,
    width: "100",
    allowFullScreen: true
  }));
};
FollowUsOnFacebook.displayName = "FollowUsOnFacebook";